<template>
  <div class="pa-1">
    <FormGroup class="mb-4">
      <v-text-field v-model="form.code" v-if="canEdit" label="コード" />
      <template v-if="!canEdit">
        <FormLabel>コード</FormLabel>
        <div>
          {{ form.code }}
        </div>
      </template>
    </FormGroup>
    <FormGroup>
      <v-textarea v-model="form.note" v-if="canEdit" label="メモ欄" />
      <template v-if="!canEdit">
        <FormLabel>メモ</FormLabel>
        <div>
          {{ form.note }}
        </div>
      </template>
    </FormGroup>
  </div>
</template>

<script>
import FormGroup from './FormGroup'
import FormLabel from './FormLabel'
import { AbstractInsertionOrdersForm } from '@/models/InsertionOrders'

export default {
  name: 'EditDetailForm',
  components: {
    FormGroup,
    FormLabel,
  },
  props: {
    form: AbstractInsertionOrdersForm,
    advertiser: Object,
    canEdit: Boolean,
  },
}
</script>

<style scoped></style>
